// extracted by mini-css-extract-plugin
export default {"description":"ulKuLk","infoSectionCollapse":"KHWbzo","button":"wofuke","icon":"aecizt"};